import Form from "./Form";
import { useToast } from "@chakra-ui/react";
import {
  useCreateLessonMutation,
  CreateLessonMutationVariables,
} from "../../generated/graphql";
import { useNavigate } from "react-router-dom";

const Create = () => {
  const [createLesson] = useCreateLessonMutation();
  const navigation = useNavigate();
  const toast = useToast();
  const handleCreateLesson = async (data: CreateLessonMutationVariables) => {
    try {
      await createLesson({
        variables: {
          data: data.data,
        },
      });

      return toast({
        status: "success",
        title: "Success",
        description: "Lesson added",
        duration: 1000,
        onCloseComplete: () => {
          return navigation("/lesson");
        },
      });
    } catch (error) {
      return toast({
        status: "error",
        title: "Error",
        description: "An error occured",
        duration: 1000,
      });
    }
  };
  return <Form handleCreateLesson={handleCreateLesson} actionType="CREATE" />;
};

export default Create;
